import { useContext, memo } from "react";
import {
  ScrollArea,
  Flex,
  Text,
  Box,
  Grid,
  Button,
  ActionIcon,
  useMantineTheme,
} from "@mantine/core";
import { CartType, formatter } from "src/utils/constants";
import { CatalogContext } from "src/api/context/CatalogContext";
import ShoppingCart from "../ShoppingCart";
import { IoIosArrowRoundBack } from "react-icons/io";
import RelatedItems from "./RelatedItems";
import SelectVariant from "./SelectVariant";
import { calculateMinMax } from "../ProductCatalogListing";

function ProductCatalogDetail() {
  const theme = useMantineTheme();
  let color = theme.colors.secondaryTextColor[6];
  const { handleCartUpdate, selectedPG, handleBack, selectedProduct } =
    useContext(CatalogContext);
  const { name, imgUrl } = selectedPG || {};

  return (
    <>
      <Grid m={0} sx={{}}>
        <Grid.Col sm={9} md={10} p={"md"}>
          <Flex
            gap={"sm"}
            align={"center"}
            sx={{ borderBottom: `1px solid #DDDDDD` }}
          >
            <ActionIcon
              onClick={handleBack}
              size={"lg"}
              sx={{
                "&:hover": {
                  backgroundColor: theme.colors.secondary[6],
                },
              }}
            >
              <IoIosArrowRoundBack color={color} size={27} />
            </ActionIcon>

            <Text size={24}>{name}</Text>
          </Flex>

          <ScrollArea
            scrollbarSize={3}
            sx={{
              ".mantine-Grid-root": {
                height: "100% !important",
              },
            }}
          >
            <Box sx={{ maxHeight: "83vh" }}>
              <Grid m={0} pt={"md"} sx={{}}>
                <Grid.Col
                  xs={12}
                  sm={5}
                  lg={5}
                  sx={(theme) => ({
                    //height: "auto",
                    background:
                      selectedProduct?.imgUrl || imgUrl
                        ? "transparent"
                        : theme.colors.gray[1],
                    minHeight: 350,
                    maxHeight: 450,
                    width: "100%",
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    borderRadius: 4,
                    overflow: "hidden",
                  })}
                >
                  {imgUrl || selectedProduct?.imgUrl ? (
                    // eslint-disable-next-line jsx-a11y/img-redundant-alt
                    <img
                      src={selectedProduct?.imgUrl || imgUrl || ""}
                      style={{
                        height: "100%",
                        width: "100%",
                        maxHeight: 450,
                        objectFit: "contain",
                      }}
                      alt="Product Image"
                    />
                  ) : null}
                </Grid.Col>
                <Grid.Col span="auto" p={"5px 30px"}>
                  <Box
                    sx={{
                      borderBottom: `1px solid #DDDDDD`,
                    }}
                    pb={2}
                  >
                    <Flex justify={"space-between"}>
                      <Text size={22}>
                        {selectedProduct?.name || selectedPG?.name}
                      </Text>
                      <Text size={22}>
                        {selectedProduct?.cost
                          ? formatter.format(selectedProduct.cost)
                          : calculateMinMax(selectedPG!.products)}
                      </Text>
                    </Flex>

                    <Text>
                      {selectedProduct
                        ? selectedProduct?.description
                        : selectedPG?.description}
                    </Text>
                  </Box>

                  <SelectVariant />
                </Grid.Col>
              </Grid>
              <Button
                sx={{
                  maxWidth: "85%",
                  margin: "auto",
                  "&:hover": {
                    backgroundColor: theme.colors.primary[4],
                  },
                }}
                radius="xl"
                size="md"
                fullWidth
                mt={"xs"}
                disabled={!selectedProduct}
                onClick={() =>
                  selectedProduct &&
                  handleCartUpdate(selectedProduct, CartType.add)
                }
              >
                {selectedProduct
                  ? "Add to Cart"
                  : " Select a product to add to the cart"}
              </Button>

              <RelatedItems />
            </Box>
          </ScrollArea>
        </Grid.Col>
        <ShoppingCart />
      </Grid>
    </>
  );
}

export default memo(ProductCatalogDetail);
